import { Injectable } from '@angular/core';
import { AuthentificationService } from '@app/authentification/authentification.service';
import { Reference } from '@app/models/reference';
import { Search, SearchResponse } from '@app/models/search';

import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { Observable, of, switchMap } from 'rxjs';
import { Dao } from '../dao';
import { DataLoader } from '../data-loader';
import { DataLoaderAuthentified } from '../data-loader-authentified';

export class PenelopEventSearch extends Search {
  status?: string[];
}

export class PenelopHistorySearch extends Search {
  date?: {
    min: string;
    max: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class PenelopDao extends Dao {
  private penelops: DataLoaderAuthentified<any[]> = new DataLoaderAuthentified<
    any[]
  >(this.getAuthentified(), user => {
    return this.httpApi.get(`/accounts/${user.accountId}/penelops`);
  });

  private references: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/penelops`),
  );
  private eventTypesReference = new DataLoader<Reference[]>(() =>
    this.httpApi.getGeneric<Reference[]>(`/ref/penelops/evenements/types`),
  );

  constructor(
    httpApi: HttpApiService,
    authentificationService: AuthentificationService,
  ) {
    super(httpApi, authentificationService);
  }

  /* Penelop */
  getContrats(): Observable<any> {
    return this.penelops.get();
  }

  getContratsByType(type: string): Observable<any> {
    return this.getContrats().pipe(
      switchMap(contrats => {
        let contrat = contrats.filter(o => o.type === type);
        return of(contrat);
      }),
    );
  }

  getEvenements(contratId: string): Observable<any[]> {
    return this.getAuthentified().pipe(
      switchMap(user => {
        return this.httpApi.get(
          `/accounts/${user.accountId}/penelops/${encodeURIComponent(
            contratId,
          )}/evenements`,
        );
      }),
    );
  }

  searchEvenements(
    contratId: string,
    payload?: PenelopEventSearch,
  ): Observable<SearchResponse> {
    return this.command(user =>
      this.httpApi.post(
        `/accounts/${user.accountId}/penelops/${encodeURIComponent(
          contratId,
        )}/evenements/search`,
        payload ?? {},
      ),
    );
  }

  searchHistories(
    contratId: string,
    payload?: PenelopHistorySearch,
  ): Observable<SearchResponse> {
    return this.command(user =>
      this.httpApi.post(
        `/accounts/${user.accountId}/penelops/${encodeURIComponent(
          contratId,
        )}/histories/search`,
        payload ?? {},
      ),
    );
  }

  getHistories(contratId: string): Observable<any[]> {
    return this.getAuthentified().pipe(
      switchMap(user => {
        return this.httpApi.get(
          `/accounts/${user.accountId}/penelops/${contratId}/histories`,
        );
      }),
    );
  }

  /* Reference */
  getReferences(): Observable<any> {
    return this.references.get();
  }

  getEventTypes(): Observable<Reference[]> {
    return this.eventTypesReference.get();
  }

  /* state */
  reset() {
    this.penelops?.reset();
  }

  onUserChange(event: any) {
    this?.reset();
  }
}
